module.exports = __webpack_public_path__ + "static/media/others (5).6aec1ff0.jpg";